import PersonOutlineIcon from "@material-ui/icons/PersonOutline";

import "./Reserva.css";
import "../Element/Element.css";

import { formatDate } from "../../helpers/formatDate";
import { decode } from "html-entities";
import { useTranslation } from "react-i18next";

const Reserva = ({ data, title, personas, CM_or_EEData, ECData }) => {
  const [t, i18n] = useTranslation("global");
  const { language } = i18n;

  return (
    <div className="reserva__container">
      <div className="reserva__info">
        <p className="reserva__secondary-title">{title}</p>
        {data && (
          <>
            {data.message ? (
              <>
                <p style={{ fontWeight: 400, width: "85%" }}>
                  {data.message === ""
                    ? t("RESUMEN.alert")
                    : decode(data.message)}
                </p>
              </>
            ) : (
              <div>
                {Object.keys(data).map((item, idx) => {
                  return (
                    <div key={idx}>
                      <p className="reserva__dateText">
                        {item === "fecha" && formatDate(data[item])}
                      </p>
                      <p>
                        {item === "horario" &&
                          `${data[item][0]} ${language == "en" ? "to" : "a"} ${
                            data[item][1]
                          }`}
                      </p>
                    </div>
                  );
                })}
              </div>
            )}
          </>
        )}
        {ECData && (
          <>
            {ECData.map((item, idx) => {
              return (
                <div className="reserva__shippingAddress" key={idx}>
                  <p className="reserva__shippingAddress-title">
                    Envio {idx + 1}
                  </p>
                  <div className="reserva__shippingAddress-addressWrapper">
                    <h3 className="reserva__secondary-title">Destino</h3>
                    <p className="reserva__shippingAddress-name">
                      {item.contactData.nombre}
                    </p>
                    <p className="reserva__shippingAddress-address">
                      {item.contactData.direccion}
                    </p>
                    <p className="reserva__shippingAddress-address">
                      {item.contactData.poblacion} -{" "}
                      {item.contactData.codigoPostal}
                    </p>
                    <p className="reserva__shippingAddress-address">
                      {item.contactData.telefono}
                    </p>
                  </div>

                  <div className="reserva__shippingAddress-nameListWrapper">
                    <h3 className="reserva__secondary-title">Licencias</h3>
                    <ul>
                      {item.certificatesList.map((certificate, idx) => {
                        return (
                          <li
                            key={idx}
                            className="reserva__shippingAddress-nameList"
                          >
                            {certificate}
                          </li>
                        );
                      })}
                    </ul>
                  </div>

                  <br />
                </div>
              );
            })}
          </>
        )}
        {CM_or_EEData && (
          <>
            <ul>
              {CM_or_EEData.map((item, idx) => {
                return (
                  <li key={idx} className="reserva__shippingAddress-nameList">
                    {item}
                  </li>
                );
              })}
            </ul>
          </>
        )}
      </div>
      <div className="reserva__quantity">
        <div className="reserva__iconContainer">
          <PersonOutlineIcon style={{ fontSize: 25 }} />
        </div>
        <div className="reserva__number">{personas}</div>
      </div>
    </div>
  );
};

export default Reserva;
